import React from "react";
import {
    Box,
    Fab,
    ListItemButton,
    ListItemButtonProps,
    ListItemText,
    Collapse as MuiCollapse,
    useTheme,
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import * as Styles from "components/formsUI/Collapse/Collapse.styles";
import { on } from "process";

interface IProps {
    defaultOpen?: boolean;
    title: string;
    children: React.ReactNode;
    onToggle?: (open: boolean) => void;
}

const Collapse = (props: IProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { defaultOpen = false, title, children, onToggle } = props;
    const [open, setOpen] = React.useState<boolean>(defaultOpen);
    const [exited, setExited] = React.useState<boolean>(!defaultOpen);

    const handleClick = () => {
        onToggle && onToggle(!open);
        setOpen(!open);
        setExited(false);
    };

    const statusListButton: ListItemButtonProps = {
        sx: Styles.statusListButton(!exited, theme),
    };

    return (
        <Box>
            <ListItemButton {...statusListButton} onClick={handleClick}>
                <ListItemText
                    primary={title}
                    primaryTypographyProps={{
                        sx: {
                            fontWeight: "bold",
                        },
                    }}
                />
                <KeyboardArrowDown
                    sx={{
                        opacity: 1,
                        transform: open ? "rotate(180deg)" : "rotate(0)",
                        transition: "0.2s",
                    }}
                />
            </ListItemButton>

            <MuiCollapse
                in={open}
                timeout={"auto"}
                unmountOnExit
                sx={Styles.collapsedContent(theme)}
                children={children}
                onExited={() => setExited(true)}
            />
        </Box>
    );
};

export default Collapse;
